import type { ReactNode } from "react";
import { Inbox } from "lucide-react";

/**
 * Shown when there is genuinely nothing to display.
 *
 * <p>`message` is worth writing properly: the difference between "no results" and an explanation
 * of why — a filter that excludes everything, or a date on which nobody was in the team — is the
 * difference between a reader thinking the system is broken and understanding the answer.
 */
export function EmptyState({
  title,
  message,
  action,
}: {
  title: string;
  message?: string;
  action?: ReactNode;
}) {
  return (
    <div className="flex flex-col items-center justify-center gap-2 px-6 py-12 text-center">
      <div className="grid h-12 w-12 place-items-center rounded-full bg-ink-100 text-ink-400">
        <Inbox className="h-6 w-6" />
      </div>
      <p className="text-sm font-medium text-ink-800">{title}</p>
      {message && <p className="max-w-sm text-sm text-ink-500">{message}</p>}
      {action && <div className="mt-2">{action}</div>}
    </div>
  );
}
